// extracted by mini-css-extract-plugin
module.exports = {"SmallModal":"SmallModal_SmallModal__1QKnl"};